export const defaultYoutubeLink = 'https://www.youtube.com/embed/2PmylfzD8NE';
